(function(){
  var d=document.documentElement;
  var ds=!!(window.Shopify&&Shopify.designMode);
  var rm=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  if(ds||rm){return;}
  var fine=!!(window.matchMedia&&window.matchMedia('(pointer: fine)').matches);

  function seasonNow(){var m=new Date().getMonth()+1;if(m===12||m<=2){return 'winter';}if(m<=5){return 'spring';}if(m<=8){return 'summer';}return 'fall';}

  function reveal(){
    if(!('IntersectionObserver' in window)){return;}
    var sel='.lux-sechead,.lux-head,.lux-pc,.lux-pr,.lux-fcard,.lux-why__item,.lux-why__wrap,.lux-wl__main,.lux-wl__card,.lux-news__box,.lux-wb__copy,.lux-ft__brand,.lux-ft__col,.lux-ft__serve,.lux-ft__bar,.lux-pdt__item,.lux-pdd__grid>div,.lux-pd__info,.lux-pd__stage,.lux-pdw__desc img,.lux-reveal-me';
    d.classList.add('lux-js');
    var els=[].slice.call(document.querySelectorAll(sel));
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(!e.isIntersecting){return;}
        var el=e.target;io.unobserve(el);
        var i=parseInt(el.getAttribute('data-lux-i')||'0',10);
        setTimeout(function(){
          el.classList.add('lux-in');
          setTimeout(function(){el.classList.remove('lux-reveal','lux-in');},900);
        },i*90);
      });
    },{threshold:0.12,rootMargin:'0px 0px -6% 0px'});
    els.forEach(function(el){
      var idx=el.parentElement?[].slice.call(el.parentElement.children).indexOf(el):0;
      el.setAttribute('data-lux-i',Math.min(idx,5));
      el.classList.add('lux-reveal');
      io.observe(el);
    });
  }

  function words(){
    if(!('IntersectionObserver' in window)){return;}
    var hs=[].slice.call(document.querySelectorAll('.lux-sechead h2,.lux-head h2'));
    var io=new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('lux-wv');io.unobserve(e.target);}});
    },{threshold:0.4});
    hs.forEach(function(h){
      if(h.children.length){return;}
      var txt=h.textContent.trim();
      if(!txt){return;}
      h.setAttribute('aria-label',txt);
      h.textContent='';
      txt.split(/\s+/).forEach(function(w,i){
        var s=document.createElement('span');s.className='lux-w';s.setAttribute('aria-hidden','true');
        var n=document.createElement('i');n.style.setProperty('--i',i);n.textContent=w;
        s.appendChild(n);h.appendChild(s);h.appendChild(document.createTextNode(' '));
      });
      io.observe(h);
    });
  }

  function extras(){
    document.addEventListener('click',function(e){
      var b=e.target.closest?e.target.closest('.lux-btn,.lux-pk__add,.lux-ft__top'):null;
      if(!b){return;}
      var r=b.getBoundingClientRect(),s=document.createElement('span');
      s.className='lux-rip';
      var dm=Math.max(r.width,r.height)*2;
      s.style.width=dm+'px';s.style.height=dm+'px';
      s.style.left=(e.clientX-r.left-dm/2)+'px';s.style.top=(e.clientY-r.top-dm/2)+'px';
      b.appendChild(s);
      setTimeout(function(){if(s.parentNode){s.parentNode.removeChild(s);}},650);
    });
    if(fine){
      var cur=null;
      document.addEventListener('mousemove',function(e){
        var el=e.target.closest?e.target.closest('.lux-pk,.lux-pc'):null;
        if(cur&&cur!==el){cur.style.setProperty('--rx','0deg');cur.style.setProperty('--ry','0deg');}
        cur=el;
        if(!el){return;}
        var r=el.getBoundingClientRect(),px=(e.clientX-r.left)/r.width-0.5,py=(e.clientY-r.top)/r.height-0.5;
        el.style.setProperty('--ry',(px*10)+'deg');el.style.setProperty('--rx',(-py*10)+'deg');
      },{passive:true});
    }
    var hc=document.querySelector('.lux-hb__copy'),wm=document.querySelector('.lux-why__media'),wc=document.querySelector('.lux-wb__copy');
    var tick=false;
    function run(){
      tick=false;
      var vh=window.innerHeight,sy=window.scrollY;
      if(hc&&sy<vh){hc.style.transform='translate3d(0,'+(sy*0.12)+'px,0)';}
      [wm,wc].forEach(function(el){
        if(!el){return;}
        var r=el.getBoundingClientRect();
        if(r.bottom<0||r.top>vh){return;}
        var o=(r.top+r.height/2-vh/2)*-0.07;
        el.style.transform='translate3d(0,'+o+'px,0)';
      });
    }
    window.addEventListener('scroll',function(){if(!tick){tick=true;requestAnimationFrame(run);}},{passive:true});
    run();
  }

  function ambient(){
    var on=true;
    try{on=localStorage.getItem('lux-snow')!=='off';}catch(e){}
    var meta=document.querySelector('meta[name=lux-season]');
    var season=meta?meta.getAttribute('content'):seasonNow();
    d.setAttribute('data-lux-season',season);
    var c=document.createElement('canvas');
    c.className='lux-snowcv';c.setAttribute('aria-hidden','true');
    var x=c.getContext('2d');
    if(!x){return;}
    var fr=document.createElement('div');
    fr.className='lux-frost is-'+season;fr.setAttribute('aria-hidden','true');
    var wxp=document.createElement('div');
    wxp.className='lux-wx';
    var wxt=document.createElement('span');
    wxt.textContent='Weather...';
    var geo=document.createElement('button');
    geo.type='button';geo.className='lux-wxgeo';
    geo.style.cssText='width:auto;height:28px;padding:0 11px;gap:6px;margin:0 -6px 0 4px;border-radius:999px;font:inherit;font-size:11.5px;font-weight:700';
    geo.innerHTML="<svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' aria-hidden='true'><path d='M12 21s7-6.2 7-11a7 7 0 1 0-14 0c0 4.8 7 11 7 11Z'/><circle cx='12' cy='10' r='2.5'/></svg>";
    var geoTxt=document.createElement('span');
    geoTxt.textContent='My location';
    geo.appendChild(geoTxt);
    geo.setAttribute('aria-label','Use my location for the weather');
    wxp.appendChild(wxt);wxp.appendChild(geo);
    var dpr=Math.min(window.devicePixelRatio||1,2),w=0,h=0,t=0,small=window.innerWidth<700;
    var P={sk:[],lv:[],pt:[],po:[],rn:[],sn:[],pr:[]};
    var LEAF=null;
    try{LEAF=new Path2D('M12 1.5l1.7 3.6 2.4-1-.7 4.5 2.9-1.8-.5 2.9 2.7-.3-1.2 2.5 2 1.1-5.2 2.9.6 2.1-3.9-.7v4.2h-1.6v-4.2l-3.9.7.6-2.1-5.2-2.9 2-1.1-1.2-2.5 2.7.3-.5-2.9 2.9 1.8-.7-4.5 2.4 1L12 1.5Z');}catch(e){}
    var LC=['#D8342A','#E8743B','#F2A93B','#B9532A'];
    var PC={winter:'#4f8fb8',spring:'#6fa860',summer:'#d99a2b',fall:'#b9532a'};
    function size(){w=window.innerWidth;h=window.innerHeight;c.width=w*dpr;c.height=h*dpr;x.setTransform(dpr,0,0,dpr,0,0);}
    function rnd(a,b){return a+Math.random()*(b-a);}
    function mkSk(){return{x:rnd(0,w),y:rnd(0,h),s:rnd(4,11),ph:rnd(0,6.28),sp:rnd(0.6,1.8),dx:rnd(-0.04,0.04),dy:-rnd(0.05,0.17)};}
    function mkLv(top){return{x:rnd(0,w),y:top?-20:rnd(0,h),s:rnd(8,16),sp:rnd(0.5,1.4),a:rnd(0,6.28),v:rnd(0.4,1),rot:rnd(0,6.28),rs:rnd(-0.03,0.03),c:LC[Math.floor(Math.random()*LC.length)]};}
    function mkPt(top){return{x:rnd(0,w),y:top?-20:rnd(0,h),s:rnd(5,10),sp:rnd(0.4,1.1),a:rnd(0,6.28),v:rnd(0.4,1),rot:rnd(0,6.28),rs:rnd(-0.03,0.03)};}
    function mkPo(){return{x:rnd(0,w),y:rnd(0,h),r:rnd(1.5,3.5),ph:rnd(0,6.28),sp:rnd(0.5,1.5),dx:rnd(0.05,0.25),dy:-rnd(0.1,0.4)};}
    function mkRn(top){return{x:rnd(0,w),y:top?-20:rnd(0,h),l:rnd(10,24),s:rnd(11,18)};}
    function mkSn(top){return{x:rnd(0,w),y:top?-10:rnd(0,h),r:rnd(3,6),s:rnd(0.5,1.3),a:rnd(0,6.28),v:rnd(0.4,1),rot:rnd(0,6.28),rs:rnd(-0.02,0.02)};}
    function fill(arr,n,mk){for(var i=0;i<n;i++){arr.push(mk(false));}}
    function star(px,py,s,al){
      x.save();x.translate(px,py);x.globalAlpha=al;
      x.beginPath();x.moveTo(0,-s);x.lineTo(s*0.22,-s*0.22);x.lineTo(s,0);x.lineTo(s*0.22,s*0.22);x.lineTo(0,s);x.lineTo(-s*0.22,s*0.22);x.lineTo(-s,0);x.lineTo(-s*0.22,-s*0.22);x.closePath();
      x.fillStyle='#ffffff';x.strokeStyle='rgba(90,150,190,0.95)';x.lineWidth=1.2;x.fill();x.stroke();
      x.restore();
    }
    function arms(r){
      x.beginPath();
      for(var i=0;i<6;i++){
        var a=i*1.0472,ca=Math.cos(a),sa=Math.sin(a);
        x.moveTo(0,0);x.lineTo(r*ca,r*sa);
        var bx=0.55*r*ca,by=0.55*r*sa,b=0.34*r;
        x.moveTo(bx,by);x.lineTo(bx+b*Math.cos(a+0.9),by+b*Math.sin(a+0.9));
        x.moveTo(bx,by);x.lineTo(bx+b*Math.cos(a-0.9),by+b*Math.sin(a-0.9));
      }
    }
    function crystal(px,py,r,rot,al){
      x.save();x.translate(px,py);x.rotate(rot);x.globalAlpha=al;x.lineCap='round';
      arms(r);x.strokeStyle='rgba(90,150,190,0.85)';x.lineWidth=2.4;x.stroke();
      arms(r);x.strokeStyle='#ffffff';x.lineWidth=1.1;x.stroke();
      x.restore();
    }
    function leaf(px,py,s,rot,col,al){
      if(!LEAF){return;}
      x.save();x.translate(px,py);x.rotate(rot);var k=s/12;x.scale(k,k);x.translate(-12,-12);x.globalAlpha=al;x.fillStyle=col;x.fill(LEAF);x.restore();
    }
    function petal(px,py,s,rot,al){
      x.save();x.translate(px,py);x.rotate(rot);x.globalAlpha=al;
      x.fillStyle='#ffaac6';x.beginPath();x.ellipse(0,0,s*0.6,s*0.35,0,0,6.283);x.fill();
      x.fillStyle='#ffd2e0';x.beginPath();x.ellipse(-s*0.15,-s*0.05,s*0.3,s*0.15,0,0,6.283);x.fill();
      x.restore();
    }
    function pollen(px,py,r,al){
      x.globalAlpha=al*0.35;x.fillStyle='#ffd35a';x.beginPath();x.arc(px,py,r*2.6,0,6.283);x.fill();
      x.globalAlpha=al;x.fillStyle='#fff3b8';x.beginPath();x.arc(px,py,r,0,6.283);x.fill();
    }
    function paw(px,py,ang,s,al){
      x.save();x.translate(px,py);x.rotate(ang+1.5708);x.globalAlpha=al;x.fillStyle=PC[season]||'#4f8fb8';
      x.beginPath();x.ellipse(0,s*0.35,s*0.55,s*0.45,0,0,6.283);x.fill();
      var T=[[-0.78,-0.15],[-0.3,-0.68],[0.3,-0.68],[0.78,-0.15]];
      for(var i=0;i<4;i++){x.beginPath();x.ellipse(s*T[i][0],s*T[i][1],s*0.2,s*0.27,0,0,6.283);x.fill();}
      x.restore();
    }
    size();
    if(season==='winter'){fill(P.sk,small?9:20,mkSk);}
    if(season==='fall'){fill(P.lv,small?8:16,mkLv);}
    if(season==='spring'){fill(P.pt,small?9:18,mkPt);}
    if(season==='summer'){fill(P.po,small?10:22,mkPo);}
    document.body.appendChild(fr);
    document.body.appendChild(c);
    document.body.appendChild(wxp);
    window.addEventListener('resize',size);

    function frame(){
      requestAnimationFrame(frame);
      if(!on||document.hidden){return;}
      t+=0.016;
      x.clearRect(0,0,w,h);
      var k,q,a,j;
      for(k=0;k<P.sk.length;k++){
        q=P.sk[k];a=(Math.sin(t*q.sp+q.ph)+1)/2;a=a*a;
        q.x+=q.dx;q.y+=q.dy;
        if(q.y<-20||q.x<-20||q.x>w+20){P.sk[k]=mkSk();P.sk[k].y=h+10;q=P.sk[k];}
        star(q.x,q.y,q.s*(0.4+0.6*a),a*0.95);
      }
      for(k=0;k<P.lv.length;k++){
        q=P.lv[k];q.y+=q.sp;q.a+=0.012*q.v;q.x+=Math.sin(q.a)*0.9;q.rot+=q.rs;
        if(q.y>h+20){P.lv[k]=mkLv(true);q=P.lv[k];}
        leaf(q.x,q.y,q.s,q.rot,q.c,0.85);
      }
      for(k=0;k<P.pt.length;k++){
        q=P.pt[k];q.y+=q.sp;q.a+=0.012*q.v;q.x+=Math.sin(q.a)*0.7;q.rot+=q.rs;
        if(q.y>h+20){P.pt[k]=mkPt(true);q=P.pt[k];}
        petal(q.x,q.y,q.s,q.rot,0.85);
      }
      for(k=0;k<P.po.length;k++){
        q=P.po[k];a=(Math.sin(t*q.sp+q.ph)+1)/2;
        q.x+=q.dx;q.y+=q.dy;
        if(q.y<-10||q.x>w+10){P.po[k]=mkPo();P.po[k].y=h+10;P.po[k].x=rnd(-10,w);q=P.po[k];}
        pollen(q.x,q.y,q.r,0.25+0.7*a);
      }
      for(k=0;k<P.sn.length;k++){
        q=P.sn[k];q.y+=q.s;q.a+=0.01*q.v;q.x+=Math.sin(q.a)*0.5;q.rot+=q.rs;
        if(q.y>h+20){P.sn[k]=mkSn(true);q=P.sn[k];}
        crystal(q.x,q.y,q.r,q.rot,0.8);
      }
      if(P.rn.length){
        x.globalAlpha=0.5;x.strokeStyle='rgba(70,120,165,0.75)';x.lineWidth=1.2;x.beginPath();
        for(k=0;k<P.rn.length;k++){
          q=P.rn[k];q.y+=q.s;q.x-=q.s*0.18;
          if(q.y>h+20||q.x<-20){P.rn[k]=mkRn(true);q=P.rn[k];}
          x.moveTo(q.x,q.y);x.lineTo(q.x-q.l*0.18,q.y+q.l);
        }
        x.stroke();
      }
      for(j=P.pr.length-1;j>=0;j--){
        q=P.pr[j];q.l-=0.011;
        if(q.l<=0){P.pr.splice(j,1);continue;}
        paw(q.x,q.y,q.a,9,q.l*0.55);
      }
      x.globalAlpha=1;
    }
    frame();
    if(fine){
      var lx=null,ly=null,side=1;
      window.addEventListener('mousemove',function(e){
        if(!on){return;}
        if(lx===null){lx=e.clientX;ly=e.clientY;return;}
        var dx=e.clientX-lx,dy=e.clientY-ly,dist=Math.sqrt(dx*dx+dy*dy);
        if(dist<58){return;}
        var ang=Math.atan2(dy,dx);side=-side;
        P.pr.push({x:e.clientX+Math.cos(ang+1.5708)*7*side,y:e.clientY+Math.sin(ang+1.5708)*7*side,a:ang,l:1});
        lx=e.clientX;ly=e.clientY;
        if(P.pr.length>18){P.pr.shift();}
      },{passive:true});
    }

    /* ---------- live weather ---------- */
    var loc=null;
    try{loc=JSON.parse(localStorage.getItem('lux-geo')||'null');}catch(e){loc=null;}
    var L={},LS={sun:false,cloud:false,fog:false};
    function layer(k,cls,build){
      if(L[k]){return;}
      var e=document.createElement('div');e.className=cls;e.setAttribute('aria-hidden','true');
      if(build){build(e);}
      document.body.appendChild(e);L[k]=e;
    }
    function syncLayers(){
      for(var k in LS){if(LS.hasOwnProperty(k)&&L[k]){L[k].style.display=(on&&LS[k])?'block':'none';}}
    }
    function label(cd){
      if(cd===0){return 'Clear';}if(cd<=2){return 'Partly cloudy';}if(cd===3){return 'Cloudy';}
      if(cd===45||cd===48){return 'Foggy';}if(cd>=51&&cd<=57){return 'Drizzle';}if(cd>=61&&cd<=67){return 'Rain';}
      if(cd>=71&&cd<=77){return 'Snow';}if(cd>=80&&cd<=82){return 'Showers';}if(cd===85||cd===86){return 'Snow showers';}
      if(cd>=95){return 'Thunderstorm';}return 'Weather';
    }
    function tip(o,rain,snow){
      var hc=document.querySelector('.lux-hb__copy');
      if(!hc){return;}
      var old=hc.querySelector('.lux-wxtip');
      if(old){old.parentNode.removeChild(old);}
      var place=loc?'Your area':'Toronto',msg=null,url=null;
      if(snow){msg=place+': '+o.t+'\u00b0C and snowing. Warm picks for little paws';url='/collections/winter-picks';}
      else if(o.t<=-10){msg=place+': '+o.t+'\u00b0C. Time to bundle up. Winter picks for little paws';url='/collections/winter-picks';}
      else if(o.t<=0){msg=place+': '+o.t+'\u00b0C. Keep those paws warm';url='/collections/winter-picks';}
      else if(rain){msg=place+': rainy day. Browse walking gear';url='/collections/walking-accessories';}
      else if(o.t>=27){msg=place+': '+o.t+'\u00b0C. Keep things comfy for your pet';url='/collections/comfort-home';}
      if(!msg){return;}
      var a=document.createElement('a');
      a.className='lux-wxtip';a.setAttribute('href',url);a.textContent=msg+' \u2192';
      var cta=hc.querySelector('.lux-hb__cta');
      if(cta){hc.insertBefore(a,cta);}else{hc.appendChild(a);}
    }
    function applyWx(o){
      var cd=o.c;
      var rain=(cd>=51&&cd<=67)||(cd>=80&&cd<=82)||cd>=95;
      var snow=(cd>=71&&cd<=77)||cd===85||cd===86;
      P.rn=[];P.sn=[];
      if(rain){fill(P.rn,small?30:70,mkRn);}
      if(snow){fill(P.sn,small?12:24,mkSn);}
      fr.classList.toggle('is-rain',rain);
      LS.sun=(cd<=1&&o.day);
      LS.cloud=(cd===2||cd===3);
      LS.fog=(cd===45||cd===48);
      if(LS.sun){layer('sun','lux-sunray');}
      if(LS.cloud){layer('cloud','lux-clouds',function(e){[['6%',90,0],['15%',120,-40],['1%',75,-20]].forEach(function(z){var s=document.createElement('span');s.className='lux-cloud';s.style.top=z[0];s.style.animationDuration=z[1]+'s';s.style.animationDelay=z[2]+'s';e.appendChild(s);});});}
      if(LS.fog){layer('fog','lux-fog2');}
      syncLayers();
      wxt.textContent=(loc?'Your area':'Toronto')+' \u00b7 '+o.t+'\u00b0C \u00b7 '+label(cd);
      geoTxt.textContent=loc?'Use Toronto':'My location';
      geo.setAttribute('aria-label',loc?'Use Toronto weather':'Use my location for the weather');
      tip(o,rain,snow);
    }
    function failWx(){wxt.textContent='Weather unavailable';}
    function getWx(force){
      var key='lux-wx2-'+(loc?'g':'t');
      if(!force){
        try{
          var cc=JSON.parse(localStorage.getItem(key)||'null');
          if(cc&&Date.now()-cc.t<1800000){applyWx(cc.d);return;}
        }catch(e){}
      }
      if(!window.fetch){failWx();return;}
      var lat=loc?loc.lat:43.65,lon=loc?loc.lon:-79.38;
      fetch('https://api.open-meteo.com/v1/forecast?latitude='+lat+'&longitude='+lon+'&current=temperature_2m,weather_code,is_day&timezone=auto')
        .then(function(r){return r.json();})
        .then(function(j){
          if(!j||!j.current){failWx();return;}
          var o={t:Math.round(j.current.temperature_2m),c:j.current.weather_code,day:j.current.is_day===1};
          try{localStorage.setItem(key,JSON.stringify({t:Date.now(),d:o}));}catch(e){}
          applyWx(o);
        })
        .catch(failWx);
    }
    geo.addEventListener('click',function(){
      if(loc){
        loc=null;
        try{localStorage.removeItem('lux-geo');}catch(e){}
        getWx(true);
        return;
      }
      if(!navigator.geolocation){return;}
      wxt.textContent='Finding your location...';
      navigator.geolocation.getCurrentPosition(function(p){
        loc={lat:Math.round(p.coords.latitude*10)/10,lon:Math.round(p.coords.longitude*10)/10};
        try{localStorage.setItem('lux-geo',JSON.stringify(loc));}catch(e){}
        getWx(true);
      },function(){getWx(false);},{timeout:8000,maximumAge:3600000});
    });
    getWx(false);

    var b=document.createElement('button');
    b.type='button';b.className='lux-snowbtn';
    b.setAttribute('aria-label','Toggle seasonal effects');
    b.setAttribute('aria-pressed',on?'true':'false');
    b.innerHTML="<svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' aria-hidden='true'><path d='M12 2v20M3.3 7l17.4 10M20.7 7 3.3 17'/></svg>";
    function show(){var v=on?'block':'none';c.style.display=v;fr.style.display=v;syncLayers();b.setAttribute('aria-pressed',on?'true':'false');}
    b.addEventListener('click',function(){
      on=!on;show();
      try{localStorage.setItem('lux-snow',on?'on':'off');}catch(e){}
    });
    show();
    document.body.appendChild(b);

    var pg=document.createElement('div');
    pg.className='lux-progress';pg.setAttribute('aria-hidden','true');
    document.body.appendChild(pg);
    function upd(){var m=d.scrollHeight-window.innerHeight;pg.style.transform='scaleX('+(m>0?Math.min(window.scrollY/m,1):0)+')';}
    window.addEventListener('scroll',upd,{passive:true});
    upd();
  }

  function init(){reveal();words();extras();ambient();}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();
